<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import ScenariosAPI from 'dashboard/api/scenarios';
import ScenarioCanvas from './ScenarioCanvas.vue';
import Mres3Canvas from './mres3/Canvas.vue';
import en from './mres3/en.json';
import ru from './mres3/ru.json';

const { t } = useI18n({ useScope: 'local', messages: { en, ru } });
const route = useRoute();
const scenario = ref(null);
const error = ref('');
onMounted(async () => {
  try {
    scenario.value = (await ScenariosAPI.show(route.params.id)).data;
  } catch (failure) {
    error.value = t('error');
  }
});
</script>

<template>
  <Mres3Canvas
    v-if="scenario?.trigger?.type === 'mres3'"
    :scenario="scenario"
  />
  <ScenarioCanvas v-else-if="scenario" />
  <p v-else class="p-8 text-sm text-n-slate-11" role="status">
    {{ error || t('loading') }}
  </p>
</template>
